import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	type: 'neutral' | 'positive' | 'negative'
}

export const Container = styled.div<Props>`
	color: ${({ type }) => {
		switch (type) {
			case 'positive':
				return helpers.color.numberPositive
			case 'negative':
				return helpers.color.numberNegative
			case 'neutral':
			default:
				return helpers.color.text
		}
	}};
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	text-align: right;
	flex-direction: column;
	row-gap: 2px;
	padding-right: 4px;
`
